import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { environment } from 'src/environments/environment';
import { I4goPaymentRequestDTO, I4goPaymentResponseDTO } from '../../models/DTO/I4goPaymentRequest.dto';
import { OOCheckItem } from '../../models/oo-check-item';

declare var $: any;

@Component({
	selector: 'app-i4go-payment',
	templateUrl: './i4go-payment.component.html',
	styleUrls: ['../../../modules/online-order/online-order.component.scss'],
})
export class I4goPaymentComponent implements OnInit {
	@Input() billingCity: string;
	@Input() billingState: string;
	@Input() billingStreet: string;
	@Input() billingZip: string;
	@Input() email: string;
	@Input() firstName: string;
	@Input() lastName: string;
	@Input() orderId: string;
	@Input() shippingCity: string;
	@Input() shippingState: string;
	@Input() shippingStreet: string;
	@Input() shippingZip: string;
	@Input() transactionAmount: number;
	@Input() venueKey: number;
	@Input() checkItems: OOCheckItem[];
	@Input() phone: string;
	@Input() continueText: string;

	@Input() i4goAccessBlock: string;
	@Input() i4goServer: string;

	@Output() i4goResponse: EventEmitter<I4goPaymentResponseDTO> = new EventEmitter<I4goPaymentResponseDTO>();

	walletEnabled: boolean = false;
	applePayEnabled: boolean = false;
	googlePayEnabled: boolean = false;

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.init();
	}

	async init() {
		if (environment.debugVenueKeys.some((i) => this.venueKey)) {
			this.app.debug = true;
		}
		if (!this.i4goAccessBlock || !this.i4goServer) {
			await this.initI4go();
		}

		await this.i4goDisplay();
	}

	async initI4go() {
		const payReqBody: I4goPaymentRequestDTO = new I4goPaymentRequestDTO({
			shipping: {
				street: this.shippingStreet,
				city: this.shippingCity,
				state: this.shippingState,
				zip: this.shippingZip,
			},
			billing: {
				street: this.billingStreet,
				city: this.billingCity,
				state: this.billingState,
				zip: this.billingZip,
			},
			customer: {
				firstName: this.firstName,
				lastName: this.lastName,
				email: this.email,
				phone: this.phone,
			},
			checkItems: this.checkItems || undefined,
		});

		const res: any = await this.focuslink.i4goPreAuth(this.venueKey, this.orderId, this.transactionAmount, payReqBody);
		this.i4goAccessBlock = res.i4go_accessblock;
		this.i4goServer = res.i4go_server;
		this.app.debug && console.log(`i4Go Preauth response: ${res}`);
		await this.app.references.delay(250);
	}

	async i4goDisplay() {
		this.app.loading(false);
		const orderId = this.orderId;

		$('#i4goFrame').i4goTrueToken({
			server: this.i4goServer,
			accessBlock: this.i4goAccessBlock,
			self: document.location,
			template: 'bootstrap2',
			url: environment.production ? 'https://i4m.i4go.com' : 'https://i4m.shift4test.com',
			walletsEnabled: true,
			debug: false,
			submitButton: {
				label: this.continueText || 'Submit!',
			},
			body: { styles: { 'background-color': '#f7f7f7' } },
			acceptedPayments: 'AX,JC,MC,NS,VS',
			payments: [
				{ type: 'VS', name: 'Visa' },
				{ type: 'MC', name: 'MasterCard' },
				{ type: 'AX', name: 'American Express' },
				{ type: 'NS', name: 'Discover' },
				{ type: 'JC', name: 'JCB' },
			],
			postalCode: {
				label: 'Zip',
				visible: true,
				required: this.billingZip ? false : true,
			},
			cardholderName: {
				label: '',
				visible: this.firstName || this.lastName ? false : true,
			},
			cvv2Code: {
				label: 'Card CVV Code',
				required: false,
				visible: false,
			},
			// streetAddress: {
			// 	label: 'Card CVV Code',
			// 	required: false,
			// 	visible: true,
			// 	placeholder: 'Card CVV Code',
			// 	message: 'Security code printed on card',
			// },
			wallet: {
				buttonType: 'checkout',
				buttonSizeMode: 'fill',
			},
			onSuccess: async (form, data) => {
				this.app.debug && console.log(`onSuccess payment`);
				this.i4goResponse.emit(
					new I4goPaymentResponseDTO({
						token: data.i4go_uniqueid,
						displayName: data.otn.cardnumber,
						postalCode: data.i4go_postalcode || this.shippingZip || this.billingZip,
						extendedCardData: data.i4go_extendedcarddata,
						applePayToken: data.i4go_applepaytoken,
						googlePayToken: data.i4go_googleppaytoken,
						firstName: data.i4go_cardholdername.split(' ').length > 0 ? data.i4go_cardholdername.split(' ')[0] : this.firstName,
						lastName: data.i4go_cardholdername.split(' ').length > 0 ? data.i4go_cardholdername.split(' ')[1] : this.lastName,
						expirationMonth: data.i4go_expirationmonth,
						expirationYear: data.i4go_expirationyear,
						cardType: data.i4go_cardtype,
						amount: this.transactionAmount,
						securityCode: data.i4go_streetaddress,
						streetAddress: data.i4go_streetaddress,
					})
				);
			},
			onFailure: (form, data) => {
				console.error(data);
			},
			onComplete: (form, data) => {
				// console.log(data);
			},
			onWalletInit: (wallet, enabled, reason) => {
				this.app.debug && console.log(`Wallet init: ${wallet}`);
				switch (wallet) {
					case 'google-pay':
						this.app.debug && console.log(`GooglePay init successful`);
						if (enabled) this.googlePayEnabled = true;
						break;
					case 'apple-pay':
						this.app.debug && console.log(`ApplePay init successful`);
						if (enabled) this.applePayEnabled = true;
						break;
					default:
						break;
				}
			},
			onWalletEnabled: (wallet, enabled, reason) => {
				this.app.debug && console.log(`Wallets enabled successfully`);
			},
		});
	}
}

// {
//   "i4go_applepaytoken": "",
//   "i4go_cardholdername": "Brandon Wermes",
//   "i4go_cardtype": "VS",
//   "i4go_expirationmonth": "07",
//   "i4go_expirationyear": "2026",
//   "i4go_extendedcarddata": "",
//   "i4go_googlepaytoken": "",
//   "i4go_metatoken": "8857673801832257",
//   "i4go_postalcode": "",
//   "i4go_response": "SUCCESS",
//   "i4go_responsecode": "1",
//   "i4go_responsetext": "",
//   "i4go_signeddata": "",
//   "i4go_streetaddress": "",
//   "i4go_uniqueid": "8048377732422257",
//   "i4go_utoken": "461622-2F1AA405-000450-00002915-16B4AC65823",
//   "otn": {
//     "apiformat": 0,
//     "apioptions": "RETURNMETATOKEN,RETURNUTOKEN,ALLDATA,MSRCAPABLE,MANUALENTRYCAPABLE",
//     "apisignature": "$",
//     "authorization": "",
//     "authsource": "E",
//     "cardnumber": "XXXXXXXXXXXX2257",
//     "cardtype": "VS",
//     "cfhttp_statuscode": "200 OK",
//     "clerk": 0,
//     "customername": "Brandon Wermes",
//     "cvv2indicator": "",
//     "cvv2valid": "",
//     "date": 123099,
//     "errorindicator": "N",
//     "errortext": "",
//     "expirationdate": "0000",
//     "expirationmonth": "07",
//     "expirationyear": 26,
//     "functionrequestcode": "E0",
//     "invoice": "",
//     "longerror": "",
//     "merchantid": 7215536,
//     "metatokendata": 8857673801832257,
//     "metatokentype": "IL",
//     "options": "",
//     "postfinishtime": 1626267953729,
//     "poststarttime": 1626267952673,
//     "posttotaltime": 1056,
//     "preauthorizedamount": 0,
//     "preauthorizedtolerance": 0,
//     "primaryamount": 0,
//     "primaryerrorcode": 0,
//     "rawline1": "OK",
//     "reference": "WT0000080977",
//     "responsecode": "",
//     "secondaryamount": 0,
//     "secondaryerrorcode": 0,
//     "shorterror": "",
//     "streetaddress": "",
//     "tagfinishtime": 1626267953730,
//     "tagstarttime": 1626267952673,
//     "tagtotaltime": 1057,
//     "time": "000000",
//     "vtimeout": 25,
//     "trackinformation": "MXXXXXXXXXXXX2257=0000?",
//     "vtranid": 0,
//     "uniqueid": 8048377732422257,
//     "utoken": "461622-2F1AA405-000450-00002915-16B4AC65823",
//     "validavs": "",
//     "vendor": "Shift4.i4Go.4.1",
//     "verbose": true,
//     "zipcode": ""
//   }
// }
